<script>
	import { getContext, onDestroy } from 'svelte'
	import { styles } from '../library/scripts/styles.js'
	import { modalCreateTextfile, storeCreateFileHandler } from '../library/scripts/Store.svelte'
	import Textarea from '../library/selectors/Textarea.svelte'
	import Button from '../library/LayoutStuff/Button.svelte'

	const globals = getContext('globals')

	const fontColor = globals.colorMain
	const colorActive = globals.colorActive
	const fontS = globals.fsS
	const fontXS = globals.fsXS
	const borderColor = globals.inputBorder
	const inputBg = globals.inputBg
	const backgroundColor = globals.inputBgFocus

	const hoverText = globals.buttonSmallHover
	const bg = globals.buttonSmallBg

	//how the user wants to be contacted
	let fileContent

	//timeouts
	let toError

	let showShader = false
	let showThank = false
	let showError = false

	//if a file has been created we show the text in div
	//sticky file
	let textFile = sessionStorage.getItem('tmpfile')
	let text
	if (textFile != null) {
		fileContent = textFile
	}

	//error handling on text input
	const variable_set_value = (event) => {
		fileContent = event.detail.value
	}

	const delete_file = () => {
		sessionStorage.clear('tmpfile')
		storeCreateFileHandler.set(false)
		fileContent = ''
	}

	const create_file = async () => {
		if (!fileContent) {
			showError = true
			showShader = true

			toError = setTimeout(() => {
				showError = false
				showShader = false
			}, 2000)
			return
		}

		storeCreateFileHandler.set(true)
		sessionStorage.setItem('tmpfile', fileContent)
		showShader = true
		showThank = true

		toError = setTimeout(() => {
			showShader = false
			showThank = false
			modalCreateTextfile.set(false)
		}, 3000)
	}

	onDestroy(() => {
		clearTimeout(toError)
	})
</script>

<main>
	<div class="title" use:styles={{ fontColor, fontS }}>
		Please enter your text and image description<br />
	</div>

	<div class="small" use:styles={{ colorActive, fontXS }}>
		* seperate text with paragraph - if it's an image enter the image name you want to describe
	</div>

	<textarea
		use:styles={{ fontXS, fontColor, inputBg, borderColor, backgroundColor }}
		bind:value={fileContent}
		rows="6"
		placeHolder="enter text"
	/>

	<div class="button_container">
		{#if fileContent}
			<Button
				on:click={delete_file}
				title="delete file"
				fontSize={fontS}
				color={fontColor}
				{bg}
				hoverBackground="none"
				{hoverText}
				shadow="none"
			/>
		{/if}
		<Button
			on:click={create_file}
			title="create file"
			fontSize={fontS}
			color={fontColor}
			{bg}
			hoverBackground="none"
			{hoverText}
			shadow="none"
		/>
	</div>

	{#if showShader}
		{#if showThank}
			<div class="shader">
				<div class="thank" use:styles={{ fontColor, fontS, inputBg, borderColor }}>
					Your file has been created<br />
				</div>
			</div>
		{/if}

		{#if showError}
			<div class="shader">
				<div class="error" use:styles={{ fontS, colorActive }}>
					Please enter your text and image description<br />
				</div>
			</div>
		{/if}
	{/if}
</main>

<style>
	main {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
		width: 100%;
	}

	textarea {
		font-size: var(--fontXS);
		color: var(--fontColor);
		width: 100%;
		background-color: var(--backgroundColor);
		border: 1px solid var(--borderColor);
		overflow-y: scroll;
		resize: none;
	}

	.shader {
		display: flex;
		position: absolute;
		justify-content: center;
		align-items: center;
		top: 0;
		left: 0;
		height: 100%;
		width: 100%;
		background-color: hsla(0, 0%, 10%, 0.9);
	}

	.thank,
	.error {
		font-size: var(--fontS);
		text-align: center;
		padding: 2%;
		background-color: var(--inputBg);
	}

	.thank {
		color: var(--fontColor);
		border: 1px solid var(--borderColor);
	}

	.error {
		color: var(--colorActive);
		border: 1px solid var(--colorActive);
	}

	.title {
		display: flex;
		justify-content: center;
		color: var(--fontColor);
		font-size: var(--fontS);
		text-align: center;
		margin-bottom: 2%;
	}

	.small {
		display: flex;
		justify-content: center;
		color: var(--colorActive);
		font-size: var(--fontXS);
		text-align: center;
		margin-bottom: 2%;
	}

	.button_container {
		display: flex;
		justify-content: flex-end;
		margin-top: 20px;
		width: 100%;
	}
</style>
